import { useEffect, useState } from "react";
import { useSettings } from "../context/SettingsContext";

// The AI-generated chapter scene art that "builds" as you scroll.
// Starts blurred/faint at the top of the chapter and resolves into a clear,
// scripture-relevant painting by the time you reach the end of the chapter.
export default function ChapterImage({ src, progress }) {
  const { theme: mode } = useSettings();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
    if (!src) return;
    const img = new Image();
    img.onload = () => setLoaded(true);
    img.src = src;
  }, [src]);

  if (!src) return null;

  // reveal curve — brighter and clearer toward the end of the chapter
  const p = Math.min(1, Math.max(0, progress));
  const maxOpacity = mode === "dark" ? 0.95 : 0.94;
  const base = mode === "dark" ? 0.55 : 0.58;
  const opacity = loaded ? base + p * (maxOpacity - base) : 0;
  const blur = (1 - p) * 9;
  const scale = 1.1 - p * 0.1;

  // light scrim only — text legibility comes from the text's own halo
  const sf = 1 - p * 0.4;
  const a = (v) => (v * sf).toFixed(3);
  const scrim =
    mode === "dark"
      ? `linear-gradient(180deg, hsl(222 18% 7% / ${a(0.68)}) 0%, hsl(222 18% 7% / ${a(0.38)}) 35%, hsl(222 18% 7% / ${a(0.38)}) 65%, hsl(222 18% 7% / ${a(0.68)}) 100%)`
      : `linear-gradient(180deg, hsl(45 38% 95% / ${a(0.58)}) 0%, hsl(45 38% 95% / ${a(0.34)}) 35%, hsl(45 38% 95% / ${a(0.34)}) 65%, hsl(45 38% 95% / ${a(0.58)}) 100%)`;

  return (
    <div className="pointer-events-none fixed inset-0" style={{ zIndex: -5 }} aria-hidden="true">
      <div
        className="absolute inset-0 bg-cover bg-center transition-[opacity,filter,transform] duration-700 ease-out will-change-[opacity,filter,transform]"
        style={{
          backgroundImage: `url(${src})`,
          opacity,
          filter: `blur(${blur}px) saturate(1.08) brightness(1.08)`,
          transform: `scale(${scale})`,
        }}
      />
      {/* readability scrim — fades as the chapter progresses */}
      <div className="absolute inset-0 transition-opacity duration-700" style={{ background: scrim }} />
    </div>
  );
}
